module.exports = __webpack_public_path__ + "img/img3.283a1ae6.png";